import { render } from "./intro.vue?vue&type=template&id=5dc00f7c"
import script from "./intro.vue?vue&type=script&lang=js"
export * from "./intro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__